<svg class="svg_icon--question" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
  <defs>
    <style>.svg_icon--question .icon{fill:currentColor;}</style>
  </defs>
  <title>Learn more</title>
  <g>
    <path class="icon"
          d="M50,4.49A45.86,45.86,0,1,0,95.86,50.35,45.91,45.91,0,0,0,50,4.49Zm0,83.93A38.07,38.07,0,1,1,88.07,50.35,38.12,38.12,0,0,1,50,88.42Z"/>
    <path class="icon"
          d="M49.07,59.81a3.79,3.79,0,0,1-3.71-3.37l-.69-4.68a3.4,3.4,0,0,1,3.17-4.13c6-.76,8.74-2.62,8.74-6V41.5c0-3.1-2.34-4.88-6.34-4.88a12.76,12.76,0,0,0-8,2.75,5.27,5.27,0,0,1-3.1,1.1,4.87,4.87,0,0,1-4.81-4.82,4.8,4.8,0,0,1,1.79-3.71,21.52,21.52,0,0,1,14.31-5c9.91,0,16.65,5.09,16.65,14.25v.13c0,8.74-6,12.32-13.55,13.84l-.21,1.24a3.85,3.85,0,0,1-3.72,3.37Zm0,4.54a5.79,5.79,0,0,1,6,5.85v.14a6,6,0,0,1-12,0V70.2A5.79,5.79,0,0,1,49.07,64.35Z"/>
  </g>
</svg>

